// Array value for Utils.getQueryString() Regex call on the current href
export const FULL_PARAMETER_DESCRIPTION_AND_VALUE = 0;
export const PARAMETER_VALUE = 1;

// URL Parameter Values
export const B2C_ERROR_DESCRIPTION = 'error_description';